import { Fade, Paper, Box } from '@mui/material';

import ChangePasswordForm from '@acorn-portal/shared/src/components/forms/change-password-form';
import PageTitle from '@acorn-portal/shared/src/components/text/PageTitle';
import { FC } from 'react';
import { useAuth } from 'react-oidc-context';

const ChangePassword: FC = () => {
	const auth = useAuth();
	const email = auth.user?.profile?.email ?? '';

	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
				maxWidth: '800px',
				margin: 'auto',
			}}
		>
			<Fade in>
				<Box sx={{ margin: '2rem', textAlign: 'center' }}>
					<PageTitle>Change Password</PageTitle>
					<ChangePasswordForm customerEmail={email} />
				</Box>
			</Fade>
		</Paper>
	);
};

export default ChangePassword;
